import { render, staticRenderFns } from "./FormaPgto.vue?vue&type=template&id=52877907&scoped=true"
import script from "./FormaPgto.vue?vue&type=script&lang=js"
export * from "./FormaPgto.vue?vue&type=script&lang=js"
import style0 from "./FormaPgto.vue?vue&type=style&index=0&id=52877907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52877907",
  null
  
)

export default component.exports